import { Container, Box, Typography } from "@mui/material";

import { useArrangement } from "../../context/ArrangementProvider";


/**
 * The create arrangement plan confirmation component
 * @returns 
 */
const ArrangementConfirmationInfoCard = () => {

  const { plan } = useArrangement();

  return plan && (
    <Box
      sx={{
        borderRadius: 0,
        border: "1px solid lightgrey",
        pb: 3,
      }}
    >
      {/* Header section */}
      <Box
        sx={{
          pb: 1,
          borderBottom: "1px solid lightgrey",
          backgroundColor: "white",
        }}
      >
        <Container>
          <Typography sx={{ fontSize: 20, fontWeight: "bold", py: 1 }}>
            Chase credit card
          </Typography>
        </Container>
      </Box>
      {/* End of header section */}

      <Box
        sx={{
          textAlign: "left",
          display: "flex",
          flexDirection: "column",
          pt: 1,
          pb: 2,
          px: 3,
        }}
      >
        <Typography
          component='label'
          htmlFor='payment-amount'
          sx={{
            fontSize: 13,
            py: 0.5,
          }}
        >
          Repayment plan amount
        </Typography>
        <Box
          id="payment-amount"
          sx={{
            backgroundColor: "#E2E2E2",
            height: "34px",
            borderRadius: 0,
            border: "1px solid #BBBBBB",
            px: 1,
            pt: 0.5,
            fontWeight: "bold",
            fontSize: 16,
          }}
        >
          {`£${plan?.instalmentAmount.toFixed(2)}`}
        </Box>

        <Typography
          component='label'
          htmlFor='payment-date'
          sx={{ fontSize: 13, pt: 1, pb: 0.5 }}
        >
          Repayment date
        </Typography>
        <Box
          id='payment-date'
          sx={{
            backgroundColor: "#E2E2E2",
            height: "34px",
            borderRadius: 0,
            border: "1px solid #BBBBBB",
            px: 1,
            py: 0.5,
            fontWeight: "bold",
            fontSize: 16,
          }}
        >
          {`${plan?.nextPaymentDate.format("DD/MM/YYYY")}`}
        </Box>

        <Typography
          component='label'
          htmlFor='last-payment-date'
          sx={{ fontSize: 13, pt: 1, pb: 0.5 }}
        >
          Arrears estimated end date
        </Typography>
        <Box
          id='last-payment-date'
          sx={{
            backgroundColor: "#E2E2E2",
            height: "34px",
            borderRadius: 0,
            border: "1px solid #BBBBBB",
            px: 1,
            py: 0.5,
            fontWeight: "bold",
            fontSize: 16,
          }}
        >
          {`${plan?.endDate.format("DD/MM/YYYY")}`}
        </Box>

        <Typography
          component='label'
          htmlFor='payment-method'
          sx={{ fontSize: 13, pt: 1, pb: 0.5 }}
        >
          Plan payment method
        </Typography>
        <Box
          sx={{
            backgroundColor: "#E2E2E2",
            height: "34px",
            borderRadius: 0,
            border: "1px solid #BBBBBB",
            px: 1,
            py: 0.5,
            fontWeight: "bold",
            fontSize: 16,
          }}
        >
          Bank Transfer
        </Box>

      </Box>
    </Box>
  );
};

export default ArrangementConfirmationInfoCard;
